import { useState } from 'react';
import { Check, Share2 } from 'lucide-react';
import { shareText } from '../native/native';

/** Update to https://zoneinai.com once the custom domain is connected. */
export const APP_SHARE_URL = 'https://zonein-82a22.web.app';

const SHARE_TEXT =
  "I've been using ZoneIn AI to clear my head — dump your messy to-do list and AI sorts it into what actually matters, in seconds. Try it free:";

/**
 * Organic-growth share button. Native app: Capacitor share sheet.
 * Mobile web: Web Share API. Desktop/fallback: clipboard.
 */
export function ShareButton({ compact = false }: { compact?: boolean }) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const result = await shareText('ZoneIn AI', `${SHARE_TEXT} ${APP_SHARE_URL}`);
    if (result === 'clipboard') {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  if (compact) {
    return (
      <button
        onClick={() => void share()}
        className="flex items-center gap-1.5 rounded-lg border border-slate-300 dark:border-slate-700 px-3 py-2 text-[11px] font-bold text-slate-600 dark:text-slate-300 transition-colors hover:bg-slate-100 dark:hover:bg-slate-800"
      >
        {copied ? <Check size={13} className="text-emerald-500" /> : <Share2 size={13} />}
        {copied ? 'Invite copied!' : 'Share with a friend'}
      </button>
    );
  }

  return (
    <button
      onClick={() => void share()}
      className="flex w-full items-center justify-center gap-2 rounded-xl border border-brand-200 dark:border-brand-500/20 bg-brand-50 dark:bg-brand-900/10 py-3 text-xs font-bold text-brand-600 dark:text-brand-400 transition-colors hover:bg-brand-100 dark:hover:bg-brand-900/20"
    >
      {copied ? <Check size={15} className="text-emerald-500" /> : <Share2 size={15} />}
      {copied ? 'Invite copied to clipboard!' : 'Share ZoneIn with a friend'}
    </button>
  );
}
